var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xls",
    transform: "translate(8404.5 -1541.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M128.822,325.365h282.3a8.822,8.822,0,0,0,8.822-8.822V157.752a8.822,8.822,0,0,0-8.822-8.822h-202.9V104.822A8.822,8.822,0,0,0,199.4,96H128.822A8.822,8.822,0,0,0,120,104.822V316.544A8.822,8.822,0,0,0,128.822,325.365Zm202.9-70.574h-52.93V219.5h52.93ZM349.365,219.5H402.3v35.287h-52.93Zm-211.722,0h52.93v35.287h-52.93Zm70.574,0h52.93v35.287h-52.93Zm52.93,52.93v35.287h-52.93V272.435Zm17.643,0h52.93v35.287h-52.93Zm0-70.574V166.574h52.93v35.287Zm-17.643,0h-52.93V166.574h52.93Zm-70.574,0h-52.93V166.574h52.93Zm-52.93,70.574h52.93v35.287h-52.93Zm211.722,35.287V272.435H402.3v35.287ZM402.3,201.861h-52.93V166.574H402.3ZM137.643,113.644h52.93V148.93h-52.93Z",
    transform: "translate(-8444.895 1602.317)",
    fill: "#009e20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.d1ebda328a7af0fb6e14fe1160ba8293.svg";
export { ForwardRef as ReactComponent };